export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Connector: ['AvigilonAccessConnector', 'AvigilonVideoConnector'],
    ConnectorDefinition: [
      'AvigilonAccessConnectorDefinition',
      'AvigilonVideoConnectorDefinition',
    ],
    JobsiteModule: [
      'JobsiteAppCheckInModule',
      'JobsiteFeaturesModule',
      'JobsiteOnboardingModule',
      'JobsitePreOnboardingModule',
    ],
    JobsiteWorkerCheckInArea: ['JobsiteAppCheckInModuleArea'],
    JobsiteWorkerCheckInFlag: [
      'JobsiteWorkerCheckInAppFarFromAreaFlag',
      'JobsiteWorkerCheckInManualOverrideFlag',
    ],
    LoginWithPinResult: ['Auth', 'LoginInvalid', 'LoginRateLimited'],
    ValidModule: [
      'JobsiteAppCheckInModule',
      'JobsiteFeaturesModule',
      'JobsiteOnboardingModule',
      'JobsitePreOnboardingModule',
    ],
    ZonesParityIdentity: ['ZonesParityExternalUser', 'ZonesParityWorker'],
  },
};
export default result;
